import _ from "lodash"
import { createSelector } from "reselect"
import { IAppState } from "../../../app/appTypes"
import { ITeam } from "../../../features/team/state/teamTypes"
import { ITeamUser } from "../../../features/teamUser/state/teamUserTypes"
import { IUser } from "../../../features/user/state/userTypes"
import { getAllUsers } from "../user"

export const getAllTeams = (state: IAppState): { [id: string]: ITeam } =>
  state.entities.teams.byId

export const getAllTeamIds = (state: IAppState): string[] =>
  state.entities.teams.allIds

export const getTeamById = (state: IAppState, id: string): ITeam =>
  state.entities.teams.byId[id]

export const getTeamByHasTeamId = (
  state: IAppState,
  ownProps: { teamId: string }
): ITeam => getTeamById(state, ownProps.teamId)

export const getTeamUserByTeamUserId = (state: IAppState, ownProps: { teamUserId: string }): ITeamUser => {
  return state.entities.teamUsers.byId[ownProps.teamUserId] ?? null
}

export const getTeamUserByUserIdAndTeamId = (state: IAppState, teamId: string, userId: string): ITeamUser => {
  const team = state.entities.teams.byId[teamId]

  if (!team || !team.teamUsers) return null
  return team.teamUsers.map(x => state.entities.teamUsers.byId[x]).find((user): boolean => {
    if (!user) return false
    return user.userId == userId
  })
}

const getAllTeamUsers = (state: IAppState): { [id: string]: ITeamUser } => state.entities.teamUsers.byId

export const getTeamUsersByTeamId = createSelector(
  [
    getTeamById,
    getAllTeamUsers
  ],
  (team, teamUsersById): ITeamUser[] => {
    if (!team?.teamUsers) return []
    return team.teamUsers.map((id) => teamUsersById[id] ?? null)
  }
)

export const getTeamMembersByTeamIds = createSelector(
  [
    getAllTeams,
    getAllUsers,
    (_state: IAppState, teamIds: string[]): string[] => teamIds
  ],
  (allTeams, allUsers, teamIds): IUser[] => {
    if (!teamIds || teamIds.length === 0) return []
    const userIds = _.uniq(
      teamIds.flatMap((id) => allTeams[id]?.users || [])
    )
    const users = userIds.map((id) => allUsers[id]).filter(Boolean)
    return _.sortBy(users, ["lastName", "firstName"])
  }
)
